export default {
	BILL: '帳單',
	CONTRACT: '合約',
	PAYMENT: '繳款',
	COLLECTION_PAYMENT: '加購/代收代付',
};




// WEBPACK FOOTER //
// ./src/store/breadCrumb.js